enum ProductTab {
  Description,
  Attributes,
  Reviews,
  Questions
}

const { Attributes, Description, Questions, Reviews } = ProductTab

const nameMapping = new Map([
  [Attributes, 'Характеристики'],
  [Description, 'Описание'],
  [Questions, 'Вопросы'],
  [Reviews, 'Отзывы']
])

namespace ProductTab {
  export function getName (productTab: ProductTab): string {
    return nameMapping.get(productTab)!
  }
}

export default ProductTab
